import script from "./SupercupTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SupercupTab.vue?vue&type=script&setup=true&lang=js"

import "./SupercupTab.vue?vue&type=style&index=0&id=4628d852&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4628d852"]])

export default __exports__